import React, {useMemo} from 'react';
import CheckedInOperatorText from "../../checkin3/CheckedInOperatorText";
import {useForm, Controller} from "react-hook-form";
import PressPalletIcon from "../PressPalletIcon";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import {TextField} from '@material-ui/core';
import * as yup from "yup";
import {yupResolver} from '@hookform/resolvers';
import BaseAdHocPage from "../../../framework/util/uicomps/BaseAdHocPage";
import StationChooserForSite from "../../stations/StationChooserForSite";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import {operatorExists} from "../operatorviewbuild/PalletBuilderController";
import CheckInStore from "../../stores/CheckInStore2";
import PeopleStore from "../../stores/PeopleStore";
import StationAdoptStore from "../../stationadopt/StationAdoptStore";


export const stationAssigned = async (id) => {
    const adopted = await new StationAdoptStore().isAdopted();
    if (!adopted)
        return false;
    else
        return true;
}


const validationManualPallet = yup.object({
    stationId: yup.string().required().test('stationId', 'Station Not Assigned', stationAssigned),
    palletId: yup.string().required(),
    loadTime: yup.date(),
    unloadTime: yup.date().min(yup.ref('loadTime')),
    loadOperatorId: yup.string().required().test('personId', 'Operator id does not exist', operatorExists),
    unloadOperatorId: yup.string().required().test('personId', 'Operator id does not exist', operatorExists)
});

const formatDateForTimePicker = (date)=> {
    return (new Date(date.getTime() - (date.getTimezoneOffset() * 60000 )).toJSON().split("\.")[0])
}

const ManualPalletInit = ({currentState, sendEvent}) => {

    const defaults = currentState.context.palletData;
    const {register, handleSubmit, errors, control, error, setValue, watch, handleBlur, getValues} = useForm({
        resolver: yupResolver(validationManualPallet),
        defaultValues: {
            stationId: defaults?.stationId
        }
    });

    const loadsDefaultVal = defaults.loadTime ? formatDateForTimePicker(defaults.loadTime) : formatDateForTimePicker(new Date());
    const unloadsDefaultVal = defaults.unloadTime ? formatDateForTimePicker(defaults.unloadTime) : formatDateForTimePicker(new Date());



    const onSubmit = async data => {
        sendEvent("NEXT", data);
    };

    const baseContentItems = [
        (
            <StationChooserForSite label='Press' fullWidth={true} name="stationId" size="small" variant="outlined" control={control} errors={errors} register={register}/>
        ),
        (
            <Grid item xs={12}>
                <TextField label='Pallet Id'
                           defaultValue={defaults.palletId}
                           helperText={errors.palletId ? errors.palletId?.message : 'Scan a pallet barcode'}
                           error={errors.palletId ? true : false}
                           inputRef={register}
                           size={'small'}
                           fullWidth
                           name={'palletId'} variant={'outlined'}/>
            </Grid>


        ),
        (<Grid item xs={12}>
                <CheckedInOperatorText inputRef={register} useReactHookForms={true}
                                       label={'Load Operator'}
                                       name={'loadOperatorId'}
                                       autofocus={true}
                                       error={errors.loadOperatorId ? true : false}
                                       fullWidth
                                       defaultValue={defaults.loadOperatorId}
                                       errorMessage={errors.loadOperatorId?.message}
                />
            </Grid>
        ),
        (
            <Grid item xs={12}>
                <TextField
                    id="datetime-local"
                    label="Load Time"
                    name={"loadTime"}
                    helperText={errors.loadTime ? errors.loadTime?.message : 'Load time'}
                    error={errors.loadTime ? true : false}
                    inputRef={register}
                    type="datetime-local"
                    defaultValue={loadsDefaultVal}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>


        ),
        (<Grid item xs={12}>
                <CheckedInOperatorText inputRef={register} useReactHookForms={true} name={'unloadOperatorId'}
                                       label={'Unload Operator'}
                                       autofocus={true}
                                       error={errors.unloadOperatorId ? true : false}
                                       fullWidth
                                       defaultValue={defaults?.unloadOperatorId}
                                       errorMessage={errors.unloadOperatorId?.message}
                />
            </Grid>
        ),
        (
            <Grid item xs={12}>
                <TextField
                    id="datetime-local"
                    label="Unload Time"
                    name={"unloadTime"}
                    helperText={errors.unloadTime ? errors.unloadTime?.message : 'Unload time'}
                    error={errors.unloadTime ? true : false}
                    inputRef={register}
                    type="datetime-local"
                    defaultValue={unloadsDefaultVal}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>


        ),
    ];

    const buttonItems = [
        (<Button type="submit" variant="contained" color="primary" fullWidth>
            Next
        </Button>)
    ];

    const form = (
        <form onSubmit={handleSubmit(onSubmit)}>
            <BaseAdHocPage icon={<PressPalletIcon/>} title={'Manual Create Pallet Manifest'}
                           description={'Enter pallet information to manually create a manifest'}
                           buttons={buttonItems}
                           content={baseContentItems}/>
        </form>
    );

    const PageInGrid = (

        <Grid container
              direction="row"
              justify="center"
              alignItems="center"
        >
            <Grid item xs={2}>
            </Grid>
            <Grid item xs={8}>
                {form}
            </Grid>
            <Grid item xs={2}>
            </Grid>
        </Grid>

    );

    return PageInGrid;
}


export default ManualPalletInit;